import L from 'leaflet';

export const DEVICE_ICONS_SVG: Record<string, string> = {
    'Camera': `<svg viewBox="0 0 24 24" width="14" height="14" fill="#ffffff"><path d="M12 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0-2c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0-4.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm8-1.5h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12z"/></svg>`,
    'BioAcoustic': `<svg viewBox="0 0 24 24" width="14" height="14" fill="#ffffff"><path d="M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-1.07-1.24-1.85-.04-1.29.98-2.36 2.27-2.4 1.3-.04 2.36.98 2.4 2.27.04 1.3-.98 2.36-2.27 2.4-.13-.01-.27-.04-.4-.08v-.19zm-3.32-6.32c-.44-.44-.68-1.04-.68-1.68 0-1.31 1.07-2.38 2.38-2.38.64 0 1.24.24 1.68.68.44.44.68 1.04.68 1.68 0 1.31-1.07 2.38-2.38 2.38-.64 0-1.24-.24-1.68-.68zm-5.68.32c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.1-.36 2.12-.97 2.95l1.43 1.43C19.46 17.15 20 15.65 20 14c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 1.65.54 3.15 1.46 4.38l1.43-1.43c-.61-.83-.97-1.85-.97-2.95zM12 2C5.37 2 0 7.37 0 14c0 2.5.77 4.82 2.08 6.74l1.44-1.44C2.39 17.65 1.8 15.89 1.8 14c0-5.63 4.57-10.2 10.2-10.2S22.2 8.37 22.2 14c0 1.89-.59 3.65-1.72 5.3l1.44 1.44C23.23 18.82 24 16.5 24 14c0-6.63-5.37-12-12-12z"/></svg>`,
    'Soil Sensor': `<svg viewBox="0 0 24 24" width="14" height="14" fill="#ffffff"><path d="M12 15c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-8c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm-7.07 7.07l1.41-1.41C7.14 11.86 8 10.53 8 9c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.53.86 2.86 1.66 3.66l1.41 1.41C17.78 12.78 17 10.99 17 9c0-2.76-2.24-5-5-5S7 6.24 7 9c0 1.99-.78 3.78-2.07 5.07zM2.93 18.07l1.41-1.41C5.74 15.26 7 13.23 7 11c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.23 1.26 4.26 2.66 5.66l1.41 1.41C19.48 16.48 18 13.9 18 11c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.9-1.48 5.48-3.07 7.07z"/></svg>`,
    'eDNA': `<svg viewBox="0 0 24 24" width="14" height="14" fill="#ffffff"><path d="M7 19c-1.1 0-2 .9-2 2h14c0-1.1-.9-2-2-2h-4v-2h3c1.1 0 2-.9 2-2h-8v-2h7c1.1 0 2-.9 2-2h-8V9h6c1.1 0 2-.9 2-2H9c0-1.1.9-2 2-2V3H7v2c1.1 0 2 .9 2 2H5c-1.1 0-2 .9-2 2h6v2H4c-1.1 0-2 .9-2 2h7v2H3c-1.1 0-2 .9-2 2h8v2H7z"/></svg>`,
};

export const DEVICE_LAYERS_CONFIG = [
    { type: 'Camera', color: '#ef4444', label: 'Camera Trap', iconSvg: DEVICE_ICONS_SVG['Camera'] },
    { type: 'BioAcoustic', color: '#a855f7', label: 'BioAcoustic', iconSvg: DEVICE_ICONS_SVG['BioAcoustic'] },
    { type: 'Soil Sensor', color: '#f97316', label: 'Soil Sensor', iconSvg: DEVICE_ICONS_SVG['Soil Sensor'] },
    { type: 'eDNA', color: '#3b82f6', label: 'eDNA', iconSvg: DEVICE_ICONS_SVG['eDNA'] },
];

export const createDeviceLeafletIcon = (type: string, color: string): L.DivIcon => {
    const svg = DEVICE_ICONS_SVG[type] || DEVICE_ICONS_SVG['Camera'];
    const html = `
        <div style="
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: ${color};
            border: 2px solid #ffffff;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: transform 0.2s ease;
        ">
            ${svg}
        </div>
    `;
    return L.divIcon({
        html,
        className: 'custom-device-map-marker',
        iconSize: [24, 24],
        iconAnchor: [12, 12],
        popupAnchor: [0, -12],
    });
};

export const getDeviceLayersForProject = (name: string) => {
    // Determine project base on site or project name
    const mangroveKeywords = ['Tipligheri', 'Maipith', 'Dwariknagar', 'Drawiknagar', 'Mangrove', 'Sundarbans', 'Sundarban'];
    const elephantKeywords = ['Mer', 'Paglam', 'Shivguri', 'Namsing', 'Elephant', 'WTI', "D'ering"];
    const agroforestryKeywords = ['PS0000', 'Agroforestry', 'Dumka'];

    if (mangroveKeywords.some(k => name.includes(k))) {
        return DEVICE_LAYERS_CONFIG.filter(l => ['Camera', 'BioAcoustic'].includes(l.type));
    } else if (elephantKeywords.some(k => name.includes(k))) {
        return DEVICE_LAYERS_CONFIG;
    } else if (agroforestryKeywords.some(k => name.includes(k))) {
        return DEVICE_LAYERS_CONFIG.filter(l => ['Camera', 'BioAcoustic', 'Soil Sensor'].includes(l.type));
    }

    return DEVICE_LAYERS_CONFIG.filter(l => ['Camera', 'BioAcoustic'].includes(l.type));
};

export const getAnalysisTypesForProject = (name: string): string[] => {
    const layers = getDeviceLayersForProject(name || '');
    return layers.map(l => l.type);
};
